import React from "react";
import "./Modal.scss";

interface ModalProps {
    close: () => void;
    children?: any;
    hideCloseButton?: boolean
}

function Modal({ children, close }: ModalProps) {
    React.useEffect(() => {
        document.body.style.overflowY = 'hidden'
        return () => {
            document.body.style.overflowY = 'scroll'
        }
    })
    if (children) return (
        <div className={`Modal ${!!children && "active"}`} onMouseDown={(event) => {event.stopPropagation(); close();}} onTouchStart={(event) => {event.stopPropagation(); close();}}>
            <div className='ModalInner' onMouseDown={(e)=>e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                {children}
                <div className='ModalInner__closeButton' onClick={(event) => { event.stopPropagation(); close() }}>
                    {/* <IconComponent iconLight={closeIcon} iconDark={closeIconDark} alt='' /> */}
                </div>
            </div>
        </div>
    );
    return null
};
export default Modal;